
export default ({ updateType, resetType }) => {
  const INITIAL_STATE = {
    subject: ''
  };

  return (state = INITIAL_STATE, action) => {
    switch(action.type) {
      case updateType:
        return {
          ...state,
          subject: action.subject
        };

      case resetType:
        return {...INITIAL_STATE};

      default:
        return state;
    }
  };
};



/** WEBPACK FOOTER **
 ** ./src/members/state/__shared__/reducersMakers/subjectMaker.js
 **/